import { z } from 'zod';

// A single alias entry coming from AzPolicyAliases.json
export const AliasSchema = z.object({
  alias: z.string(),
  resourceType: z.string(),
});
export type Alias = z.infer<typeof AliasSchema>;

// Array of modifiable alias identifiers from modAlias.json
export const ModAliasSchema = z.string().array();
export type ModAliasList = z.infer<typeof ModAliasSchema>;

// Final shape returned to the UI
export interface AliasEntry {
  id: string;
  resourceType: string;
  modifiable: boolean;
} 